import { CardWrapper } from '@design-system';
import classNames from 'classnames';

import { ImageSizes } from '../../helpers/images';
import { Image } from '../Image';

type Props = {
  thumbnail?: {
    filename: string;
    alt?: string;
    copyright?: string;
    focus?: string;
  };
  image: {
    filename: string;
    alt?: string;
    copyright?: string;
    focus?: string;
  };
  imageSize?: ImageSizes;
  title?: string;
  description?: string;
};

export const ImageCard = ({
  description,
  image,
  imageSize,
  thumbnail,
  title,
}: Props) => {
  const hasTitle = Boolean(title);
  const hasDescription = Boolean(description);

  return (
    <CardWrapper
      hideOverlay={!hasTitle && !hasDescription}
      image={image}
      imageSize={imageSize}
      variant="image"
    >
      <span
        className={classNames(
          'aspect-[var(--aspect-sm)]',
          'md:aspect-[var(--aspect-md)]',
          'lg:aspect-[var(--aspect-lg)]',
          'flex w-full flex-col items-start justify-end gap-3 overflow-hidden p-4 md:p-6',
        )}
        style={
          {
            '--aspect-sm': imageSize?.sm?.ratio || '1/1',
            '--aspect-md': imageSize?.md?.ratio || '1/1',
            '--aspect-lg': imageSize?.lg?.ratio || '1/1',
          } as React.CSSProperties
        }
      >
        <span className="flex w-full max-w-xl gap-3">
          {thumbnail && thumbnail.filename ? (
            <span className="shrink-0">
              <Image
                alt={thumbnail.alt || ''}
                className="h-12 w-12"
                focus={thumbnail?.focus}
                shape="rounded"
                src={thumbnail.filename}
                width={48}
              />
            </span>
          ) : null}
          <span className="flex w-full flex-1 flex-col items-center justify-center">
            <span className="line-clamp-1 w-full text-pretty font-bold">
              {title}
            </span>
            <span className="line-clamp-1 w-full text-pretty">
              {description}
            </span>
          </span>
        </span>
      </span>
    </CardWrapper>
  );
};
